import { AccountJwt, accountJwt } from "@common/domain";
import { JsonSchemaValidator } from "@common/json-schema-validator";

export class GuestAccountSignInResponseDTO {
  private static validation = JsonSchemaValidator.compile(
    GuestAccountSignInResponseDTO.validationSchema()
  );

  constructor(readonly value: GuestAccountSignInResponseDTORaw) {
    JsonSchemaValidator.assert(GuestAccountSignInResponseDTO.validation, value);
  }

  private static validationSchema() {
    return {
      type: "object",
      required: ["token"],
      properties: {
        token: accountJwt
      },
      additionalProperties: false
    };
  }
}

export interface GuestAccountSignInResponseDTORaw {
  token: AccountJwt;
}
